// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'f340267a9403ff184d9342881d7c7a5dbfb98733';
export const BUILD_NUMBER = '199';
export const BUILD_TIMESTAMP = '2026-07-22T03:54:57.430Z';
